{
  "Clear search": "Изчистване на търсене"
}